import React from 'react'
import { Row, Col, Alert, Space } from 'antd'
import TimeLine from './timeline'
import './index.less'
class VideoPath extends React.Component {
  
  render() {
    const Homedata=this.props.Homedata
    const path=this.props.path
    const {alert,message}=this.props
    return (
      <div className="videoPath">
        <Space direction="vertical" size={32}>
        { alert?<Row justify="center">
            <Col xl={15} lg={15} md={20} xs={20}>
             <Alert
                message={message}
                type="error"
              />
            </Col>
          </Row>:null}
          <div className="path">
            <Row justify="center">
              <Col xl={20} lg={23} md={20} xs={20}>
                <Row>
                  <Col span={24}>
                    <TimeLine Homedata={Homedata} path={path} alert={alert}/>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Space>
      </div>
    )
  }
}

export default VideoPath
